import React from 'react';
import PropTypes from 'prop-types';
import InfoSelectField from 'ntnu-react/material/InfoSelectField';
import MenuItem from 'material-ui/MenuItem';


import info from '../constants/infotexts.json';
import choices from '../constants/choices.json';

const { Risk } = choices;

const styles = {
    flex: {
        flex: 1,
        marginBottom: '2em',
    },
};


class RiskTab extends React.Component {
    shouldComponentUpdate(nextProps) {
        const old = this.props.data;
        const next = nextProps.data;

        return old.Risk1 !== next.Risk1
        || old.Risk2 !== next.Risk2
        || old.Risk3 !== next.Risk3
        || old.Risk4 !== next.Risk4;
    }

    handleSelectChange = (field) => {
        return (e, index, value) => {
            this.props.fieldChange(field, value, true);
        };
    }

    render() {
        const { data } = this.props;

        return (
            <section style={{
                display: 'flex',
                flexDirection: 'column',
            }}>
                <InfoSelectField
                    floatingLabelText="Kompleksitet"
                    infoText={info.risk.Risk1}
                    value={data.Risk1}
                    onChange={this.handleSelectChange('Risk1')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Risk.Risk1.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Risk1 === item.key}
                        />
                    ))}
                </InfoSelectField>

                <InfoSelectField
                    floatingLabelText="Akseptert nivå/ kontrovers."
                    infoText={info.risk.Risk2}
                    value={data.Risk2}
                    onChange={this.handleSelectChange('Risk2')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Risk.Risk2.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Risk2 === item.key}
                        />
                    ))}
                </InfoSelectField>
                <InfoSelectField
                    floatingLabelText="Ressurser og kompetanse"
                    infoText={info.risk.Risk3}
                    value={data.Risk3}
                    onChange={this.handleSelectChange('Risk3')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Risk.Risk3.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Risk3 === item.key}
                        />
                    ))}
                </InfoSelectField>

                <InfoSelectField
                    floatingLabelText="IT-arkitektur"
                    infoText={info.risk.Risk4}
                    value={data.Risk4}
                    onChange={this.handleSelectChange('Risk4')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Risk.Risk4.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Risk4 === item.key}
                        />
                    ))}
                </InfoSelectField>
            </section>
        );
    }
}

RiskTab.propTypes = {
    data: PropTypes.object.isRequired,
    fieldChange: PropTypes.func.isRequired,
    style: PropTypes.object,
    disabled: PropTypes.bool,
};

export default RiskTab;



// WEBPACK FOOTER //
// ./src/components/RiskTab.js